
<template>
  <v-container fluid dark>
    <div class="characters-display">
        <div v-if="Object.keys(storyFaces).length>0">
            <v-expansion-panel
                v-model="panel"
                dark
                expand
            >
            <v-expansion-panel-content>
            <template v-slot:header>
                Faces
            </template>
            <div class="pa-2">
                <v-card-text class="scrolling-wrapper-flexbox">
                <v-layout row align-content-center>
                <v-flex
                    v-for="(face, faceId) in storyFaces"
                    :key="faceId"
                    v-on:click="imgselected(faceId)"
                >
                <img height="100px" :src="face.thumb" style="box-shadow: 0 0 3pt 2pt white;" v-if="selectedId==faceId" >
                <img height="80px" :src="face.thumb" v-else >
                </v-flex>
                </v-layout>
                </v-card-text>
                <div v-if="selectedId && storyFaces[selectedId]">
                    <v-select label="Language" v-model="currentLanguage" v-on:change="onUpdateNativeLanguage(selectedId)" :items="languages"></v-select>
                    <v-select label="Voice" v-model="currentVoice" v-on:change="onUpdateVoice(selectedId)" :items="voices"> </v-select>
                    <v-text-field label="Name" v-model="faceIdToName[selectedId]" @input="onUpdateName()" :rules="nameRules"></v-text-field>
                    <v-btn
                        v-on:click="onDelete(selectedId)">
                        Delete
                    </v-btn>
                    <v-btn
                        v-on:click="onChangeFace()">
                        Change
                    </v-btn>
                </div>
            </div>
            </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
    </div>
    <character-picker class="modaloverlay" v-show="showPicker"
      @close="toggleFacePicker"
      @faceId="changeFaceId"
      @newFace="readPicture"
    ></character-picker>
    <image-uploader class="modaloverlay" v-show="showUploader" :bIsRemote="bIsRemote"
      ref="imageUploader"
      @close="toggleUploader"
      @faceId="changeFaceId"
      @newPicBlobs="newPicBlobs"
    ></image-uploader>
  </v-container>
</template>
<script>
import CharacterPicker from '@/components/CharacterPicker/CharacterPicker'
import Uploader from '@/components/CharacterPicker/Uploader'
import Voice from '../../tts/voice'
import firebase from 'firebase/app'
import Vue from 'vue'
import {SmoothFile} from 'smooth-script'

export default {
  name: 'character-display',
  components: {
    'character-picker': CharacterPicker,
    'image-uploader': Uploader
  },
  props: {
    bIsRemote: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      languages: [],
      voices: [],
      storyFaces: {},
      currentLanguage: 'English',
      currentVoice: '',
      currentName: '',
      storyVoicesById: {},
      faceIdToName: {},
      showPicker: false,
      showUploader: false,
      selectedId: null,
      bAddMode: true,
      bPreventFaceChange: false,
      panel: [true],
      nameRules: [
        v =>
          v.length > 0 || 'You must provide a name',
        v =>
          v.indexOf(' ') === -1 || 'Spaces not allowed',
        v => {
          if (Object.values(this.faceIdToName).length !== [...new Set(Object.values(this.faceIdToName))].length) {
            this.bPreventFaceChange = true
            return 'Name in use'
          }
          this.bPreventFaceChange = false
          return false
        }
      ]
    }
  },
  computed: {
    faces () {
      return this.$store.getters['main/allfaces']
    },
    localfaces () {
      return this.$store.getters['main/localfaces']
    },
    initialized () {
      return this.$store.getters['main/bInitialized']
    },
    defaultOptions () {
      return this.$store.getters['main/defaultOptions']
    }
  },
  methods: {
    imgselected: function (faceId) {
      if (this.bPreventFaceChange) {
        return
      }
      this.selectedId = faceId
      if (!(faceId in this.faceIdToName)) {
        throw new Error('unknown faceId for faceIdToName')
      }
      if (!(this.selectedId in this.storyVoicesById)) {
        throw new Error('unknown id for storyVoicesById: ' + this.selectedId)
      }
      this.currentLanguage = this.storyVoicesById[this.selectedId].language
      this.currentVoice = this.storyVoicesById[this.selectedId].name
      this.onRefreshLanguageList()
      // In case voices  aren't available..
      this.storyVoicesById[this.selectedId].name = this.currentVoice
    },
    onInitialized: function () {
      if ('speechSynthesis' in window) {
        speechSynthesis.onvoiceschanged = () => {
          this.onRefreshLanguageList()
        }
        this.onRefreshLanguageList()
      }
    },
    onAdd: function () {
      this.bAddMode = true
      this.toggleFacePicker()
    },
    onChangeFace: function () {
      this.bAddMode = false
      this.toggleFacePicker()
    },
    onUpdateName: function () {
      this.$emit('modified', this.generateCommands())
    },
    toggleFacePicker: function () {
      this.showPicker = !this.showPicker
    },
    readPicture: function (e) {
      this.$refs['imageUploader'].readPicture(e)
      this.toggleUploader()
    },
    toggleUploader: function () {
      this.showUploader = !this.showUploader
    },
    newPicBlobs: function (args) {
      var originalOnFinished = args.onFinished
      args.onFinished = (faceData) => {
        this.changeFaceId(args.faceId)
        originalOnFinished(faceData)
      }
      this.$emit('newPicBlobs', args)
    },
    onUpdateNativeLanguage: function () {
      this.storyVoicesById[this.selectedId].language = this.currentLanguage
      this.onRefreshLanguageList()
      this.storyVoicesById[this.selectedId].name = this.currentVoice
      var optionsCopy = JSON.parse(JSON.stringify(this.defaultOptions))
      optionsCopy.nativeLanguage = this.currentLanguage
      this.$store.dispatch('main/updateDefaultOptions', optionsCopy)
      this.$emit('modified', this.generateCommands())
    },
    onUpdateVoice: function () {
      this.storyVoicesById[this.selectedId].name = this.currentVoice
      this.$emit('modified', this.generateCommands())
    },
    onRefreshLanguageList: function () {
      // Whenever the available tts voices/languages changes,
      // we get the voice best aligned, and display
      // the language and voice name associated with that.
      // We do NOT explicitly change the voice, unless the user manually
      // changed voice or language (or there is a null voice).
      this.languages = Voice.getLangauges()
      this.voices = Voice.getVoicesForLangauge(this.currentLanguage)
      if (this.voices.indexOf(this.currentVoice) === -1) {
        this.currentVoice = this.voices[0]
      }
    },
    onDelete: function (faceId) {
      delete this.faceIdToName[faceId]
      delete this.storyVoicesById[faceId]
      Vue.delete(this.storyFaces, faceId)
      if (faceId === this.selectedId && Object.keys(this.faceIdToName).length) {
        this.imgselected(Object.keys(this.faceIdToName)[0])
      }
      this.$emit('modified', this.generateCommands())
      this.$emit('delete', faceId)
    },
    changeFaceId: function (faceId) {
      if (!faceId || !(faceId in this.faces)) {
        throw new Error('Unknown face: ' + faceId)
      }
      this.currentLanguage = 'English'
      if (this.defaultOptions.nativeLanguage in Voice.languagePropertiesInverted) {
        this.currentLanguage = this.defaultOptions.nativeLanguage
      }
      this.onRefreshLanguageList()

      if (this.bAddMode) {
        this.faceIdToName[faceId] = faceId
        this.storyVoicesById[faceId] = {language: this.currentLanguage, name: this.currentVoice}
      } else {
        this.faceIdToName[faceId] = this.faceIdToName[this.selectedId]
        this.storyVoicesById[faceId] = JSON.parse(JSON.stringify(this.storyVoicesById[this.selectedId]))
        this.onDelete(this.selectedId)
      }
      var face = JSON.parse(JSON.stringify(this.faces[faceId]))
      this.storyFaces[faceId] = face

      this.imgselected(faceId)

      this.panel = [true]
      this.generateCommands()
      this.$emit('modified', this.generateCommands())
    },
    // Returns a string of commands so we can process this information as if it were
    // written in the main text.
    generateCommands: function () {
      var t = ''
      var id = ''
      var name = ''
      // Voices printed before names, so the voice exists when create_face is called
      for (id in this.faceIdToName) {
        name = this.faceIdToName[id]
        var storyVoice = this.storyVoicesById[id]
        if (!storyVoice) {
          console.log(this.storyVoicesById)
          throw new Error('unknown voice: ' + id)
        }
        var locale = Voice.languagePropertiesInverted[storyVoice.language]
        if (!locale) {
          console.warn(storyVoice)
          console.log(Voice.languagePropertiesInverted)
        }
        var gender = Voice.isMale(storyVoice.name) ? 'male' : 'female'
        var voiceName = storyVoice.name
        t += 'create_voice("' + name + '", "' + locale + '", "' + gender + '", "' + voiceName + '")\n'
      }
      for (id in this.faceIdToName) {
        name = this.faceIdToName[id]
        t += 'create_face("' + id + '", "' + name
        if (!(id in this.localfaces) && id in this.faces) {
          // Local files will have large data URLs that we don't want to duplicate as strings here
          t += '", "' + this.faces[id].apng + '", "' + this.faces[id].thumb
        }
        t += '")\n'
      }
      return t
    },
    updateFromContext: function (context) {
      var faces = SmoothFile.getFacesInLines(context.defaultFile.preambleLines)
      for (var id in faces) {
        var name = faces[id].name
        this.faceIdToName[id] = name

        // use this.faces instead of context.faces because the apng and thumb links aren't always in the context
        Vue.set(this.storyFaces, id, JSON.parse(JSON.stringify(this.faces[id])))
        var voice = context.voices[name]
        if (voice) {
          var voiceName = voice.name
          var localeSubstring = voice.locale.substring(0, 2)
          if (!(localeSubstring in Voice.languageProperties)) {
            console.warn('Unknown voice locale: ' + voice.locale)
          }
          var language = Voice.languageProperties[localeSubstring]
          this.storyVoicesById[id] = {name: voiceName, language: language}
        } else {
          console.warn('No voice ' + name + ' in context.voices')
          console.log(context.voices)
        }
        this.imgselected(id)
      }
    }
  },
  created: function () {

  },
  mounted: function () {
    if (this.initialized) {
      this.onInitialized()
    }
  },
  watch: {
    initialized: function (newVal, oldVal) {
      firebase.auth().onAuthStateChanged((changeduser) => {
        this.user = changeduser
      })

      if (newVal && !oldVal) {
        this.onInitialized()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CharacterPicker/CharactersDisplay.vue